import { AddOperation, Operation } from "rfc6902/diff";
import { Competence } from "../CompetenceListService";

export function processCompetenceListExcel(data: string[][]): Operation[] {
	const patches: AddOperation[] = [];
	let indices: number[] = [];
	for (const element of data) {
		if (element.length < 2) {
			// TODO: invalid line. Report to user.
			continue;
		}

		if (element[0] === undefined || element[1] === undefined) {
			// TODO: invalid line. Report to user.
			continue;
		}

		const level = parseInt(element[0]) - 1;
		const value = element[1].toString();

		if (level > indices.length) {
			// There seems to be a level missing.
			// TODO: invalid line. Report to user.
			continue;
		}

		// First cut indices to size if needed.
		if (level < indices.length - 1) {
			indices = indices.slice(0, level + 1);
		}

		if (level === indices.length - 1) {
			++indices[level];
		} else if (level === indices.length) {
			indices.push(0);
		}

		const index = indices.join("/subcompetences/");
		patches.push({
			op: "add",
			path: "/competences/" + index,
			value: new Competence(value)
		});
	}

	return patches;
}
